// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Actions cell with Document Manager button.
 * Delete moved to Document Manager panel.
 */
import type { FC } from 'react'
import { Layers } from 'lucide-react'
import {
  Tooltip,
  TooltipTrigger,
  DarkTooltipContent,
  TooltipProvider,
} from '@/components/ui'

import type { DocumentListItem } from '@/subsystems/documents'

export interface ActionsCellProps {
  document: DocumentListItem
  onOpenDocumentManager: (documentId: string) => void
}

export const ActionsCell: FC<ActionsCellProps> = ({
  document,
  onOpenDocumentManager,
}) => {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="h-7 w-7 flex items-center justify-center rounded text-muted-foreground hover:text-foreground hover:bg-muted transition-colors duration-150"
            data-testid={`cr-doc-manager-${document.documentId}`}
            onClick={() => onOpenDocumentManager(document.documentId)}
          >
            <Layers size={16} />
            <span className="sr-only">Document Manager</span>
          </button>
        </TooltipTrigger>
        <DarkTooltipContent side="top">Document Manager</DarkTooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
